import { render, staticRenderFns } from "./dividends.vue?vue&type=template&id=793dabd2&scoped=true&"
import script from "./dividends.vue?vue&type=script&lang=js&"
export * from "./dividends.vue?vue&type=script&lang=js&"
import style0 from "./dividends.vue?vue&type=style&index=0&id=793dabd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793dabd2",
  null
  
)

export default component.exports